export default __webpack_public_path__ + "static/media/smartphone.07f72644.svg";